module.exports = __webpack_public_path__ + "static/img/Nine of Wands.1ffc326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Nine of Wands.jpg
// module id = 1286
// module chunks = 0